const Getters = {
  getNoticeListFromState: (state) => {
    return state.noticeList
  }
}

export default Getters
